// extracted by mini-css-extract-plugin
module.exports = {"title":"ratesTable_title__1_huC","description":"ratesTable_description__nVoDr","disclaimer":"ratesTable_disclaimer__8Axan"};